import { Box } from '@chakra-ui/react';
import { flexRender } from '@tanstack/react-table';

import { TableCellShadow } from './Table.styles';

interface Props {
  needsShadow: boolean;
  comp: any;
  props: any;
}

export const ShadowCell: React.FC<Props> = ({ needsShadow, comp, props }) => {
  return (
    <>
      <Box zIndex={2} position={needsShadow ? 'relative' : 'static'}>
        {flexRender(comp, props)}
      </Box>
      {needsShadow ? <Box {...TableCellShadow} /> : null}
    </>
  );
};
